<template>
  <div class="px-30 py-10 h-100" ref="triesTab">
    <div class="row gx-15 gap-15" v-if="!loadingState">
      <div class="col-4 px-0" style="width: 397px">
        <div class="system-block">
          <p class="fw-bolder fsc-12 mb-10 text-dark">
            {{ dataLang['vehicle_modal_tires_modals_text1'] }}
          </p>
          <div class="wp-100 mb-15">
            <BaseCheckboxV2 v-if="triesList" placeholder="" class="mb-10" input-name="isActive"
              v-model="triesList[0].isActive" signClass="fsc-12 fw-bolder text-dark" @oncheckeds="changeCheckbox"
              :additionalParams="{ ...triesList[0], once: 'first' }" :disabled="triesList[0].isActive" name="isActive">
              {{
                dataLang['vehicle_modal_tires_text1']
              }}</BaseCheckboxV2>
          </div>
          <div class="fsc-12 fw-bolder mb-10" style="line-height: 15px;">Лето (ID комплекта на складе {{triesList[0].vehicle_tires__id}})</div>
          

          <div ref="vehicle_tires__name" class="mb-10">
            <BaseInputNew placeholder="" :width="'284'" input-name="vehicle_tires__name" @input="updateValue"
              :horizontalTitle="true" :value="triesList[0].vehicle_tires__name" :additionalParams="triesList[0]"
              :name-sign="dataLang['vehicle_modal_tires_text3']">
            </BaseInputNew>
          </div>
          <div ref="vehicle_tires__size" class="mb-10">
            <BaseInputNew placeholder="000/00/00" :width="'284'" input-name="vehicle_tires__size" @input="updateValue"
              :horizontalTitle="true" :value="triesList[0].vehicle_tires__size" :additionalParams="triesList[0]"
              inputRef="size1" inputMask="000/00/00" :name-sign="dataLang['vehicle_modal_tires_text4']" maxLength="9">
            </BaseInputNew>
          </div>
          <div class="d-flex gap-5 mb-10 align-items-center justify-content-between">
            <div ref="vehicle_tires__bought_at" class="d-flex justify-content-between align-items-center" style="gap: 8px">
              <span class="text-muted fsc-11">
                {{ dataLang['vehicle_modal_tires_text5'] }}
              </span>
              <div>
                <BaseDatePicker v-model="triesList[0].vehicle_tires__bought_at" :clearable="false" type="date"
                  class="fsc-11 idiots-class-for-input-date" lang="ru" id="vehicle_tires__bought_at"
                  style="width: 100px" value-type="format" :format="userSetting.company__tempalte_date" @change="
                    (date) =>
                      changeDate(date.split('.').reverse().join('-') + ' ' + '00:00', 'vehicle_tires__bought_at', triesList[0])
                  "></BaseDatePicker>
              </div>
            </div>
            <div ref="vehicle_tires__odometr">
              <BaseInputNew placeholder="" :width="'100'" input-name="vehicle_tires__odometr" @input="updateValue"
                :horizontalTitle="true" :value="triesList[0].vehicle_tires__odometr" :additionalParams="triesList[0]"
                :name-sign="dataLang['vehicle_modal_tires_text6']">
              </BaseInputNew>
            </div>
          </div>
          <div ref="vehicle_tires__is_another_disks" class="wp-100">
            <BaseCheckboxV2 placeholder="" class="mb-10" input-name="vehicle_tires__is_another_disks"
              v-model="triesList[0].vehicle_tires__is_another_disks" signClass="fsc-12 " @oncheckeds="updateValue"
              :additionalParams="triesList[0]">{{ dataLang['vehicle_modal_tires_text7'] }}</BaseCheckboxV2>
          </div>
          <div @click="loadDoc(triesList[0].vehicle_tires__id)" 
            class="base-button base-button--action gap-15 mb-10" style="padding-block: 12px;">
            <span class="fsc-14">
              РАСПЕЧАТАТЬ СТИКЕРЫ ЛЕТО <br/>
              <span class="fw-medium fsc-12">(для склада)</span>

            </span>
          </div>

          <div @click="$modal.show('orderSendModal', { productId: 4, productName: 'Шины и диски', objectId: currentOpenedId })" style="padding-block: 12px; background-color: #023F8F; line-height: 20px;"
            class="text-center fsc-14 rounded-5 cursor-pointer text-white mb-10">
            ЗАКАЗАТЬ НОВЫЕ ЛЕТНИЕ ШИНЫ <br/>
            <span class="fw-medium fsc-12" style="line-height: 12px;">с доставкой</span>

          </div>
          <div @click="$modal.show('orderSendModal', { productId: 5, productName: 'Шины б/у', objectId: currentOpenedId })" style="padding-block: 12px; background-color: #023F8F; line-height: 20px;"
            class="text-center fsc-14 rounded-5 cursor-pointer text-white">
            ЗАКАЗАТЬ Б/У ЛЕТНИЕ ШИНЫ <br/>
            <span class="fw-medium fsc-12" style="line-height: 12px;">с доставкой</span>
          </div>
        </div>
      </div>
      <div class="col-4 px-0" style="width: 397px">
        <div class="system-block">
          <p class="fw-bolder fsc-12 mb-10 text-dark">
            {{ dataLang['vehicle_modal_tires_modals_text2'] }}
          </p>
          <div class="wp-100 mb-15">
            <BaseCheckboxV2 placeholder="" class="mb-10" v-if="triesList" :disabled="triesList[1].isActive"
              input-name="isActive" v-model="triesList[1].isActive" signClass="fsc-12 fw-bolder text-dark"
              @oncheckeds="changeCheckbox" :additionalParams="{ ...triesList[1], once: 'second' }" name="isActive">{{
                dataLang['vehicle_modal_tires_text1']
              }}</BaseCheckboxV2>
          </div>
          <div class="fsc-12 fw-bolder mb-10" style="line-height: 15px;">Лето (ID комплекта на складе {{triesList[1].vehicle_tires__id}})</div>

          <div ref="vehicle_tires__name" class="mb-10">
            <BaseInputNew placeholder="" :width="'284'" input-name="vehicle_tires__name" @input="updateValue"
              :horizontalTitle="true" :value="triesList[1].vehicle_tires__name" :additionalParams="triesList[1]"
              :name-sign="dataLang['vehicle_modal_tires_text3']">
            </BaseInputNew>
          </div>
          <div ref="vehicle_tires__size" class="mb-10">
            <BaseInputNew placeholder="000/00/00" :width="'284'" input-name="vehicle_tires__size" @input="updateValue"
              :horizontalTitle="true" :value="triesList[1].vehicle_tires__size" :additionalParams="triesList[1]"
              inputRef="size2" inputMask="000/00/00" :name-sign="dataLang['vehicle_modal_tires_text4']" maxLength="9">
            </BaseInputNew>
          </div>
          <div class="d-flex gap-5 mb-10 align-items-center justify-content-between">
            <div ref="vehicle_tires__bought_at" class="d-flex justify-content-between align-items-center" style="gap: 8px">
              <span class="text-muted fsc-11">
                {{ dataLang['vehicle_modal_tires_text5'] }}
              </span>
              <div>
                <BaseDatePicker v-model="triesList[1].vehicle_tires__bought_at" :clearable="false" type="date"
                  class="fsc-11 idiots-class-for-input-date" lang="ru" id="vehicle_tires__bought_at"
                  style="width: 100px" value-type="format" :format="userSetting.company__tempalte_date" @change="
                    (date) =>
                      changeDate(date.split('.').reverse().join('-') + ' ' + '00:00', 'vehicle_tires__bought_at', triesList[1])
                  "></BaseDatePicker>
              </div>
            </div>
            <div ref="vehicle_tires__odometr">
              <BaseInputNew placeholder="" :width="'100'" input-name="vehicle_tires__odometr" @input="updateValue"
                :horizontalTitle="true" :value="triesList[1].vehicle_tires__odometr" :additionalParams="triesList[1]"
                :name-sign="dataLang['vehicle_modal_tires_text6']">
              </BaseInputNew>
            </div>
          </div>
          <div class="d-flex">
            <div ref="vehicle_tires__is_another_disks" class="wp-60">
              <BaseCheckboxV2 placeholder="" class="mb-10" input-name="vehicle_tires__is_another_disks"
                v-model="triesList[1].vehicle_tires__is_another_disks" signClass="fsc-12 "
                :additionalParams="triesList[1]" @oncheckeds="updateValue">{{ dataLang['vehicle_modal_tires_text8'] }}
              </BaseCheckboxV2>
            </div>
            <div ref="vehicle_tires__is_thorns" class="wp-40">
              <BaseCheckboxV2 placeholder="" class="mb-10" input-name="vehicle_tires__is_thorns"
                v-model="triesList[1].vehicle_tires__is_thorns" signClass="fsc-12 " :additionalParams="triesList[1]"
                @oncheckeds="updateValue">{{ dataLang['vehicle_modal_tires_text9'] }}</BaseCheckboxV2>
            </div>
          </div>
          <div @click="loadDoc(triesList[1].vehicle_tires__id)"
            class="base-button base-button--action gap-15 mb-10" style="padding-block: 12px;">
            <span class="fsc-14">
              РАСПЕЧАТАТЬ СТИКЕРЫ ЗИМА <br/>
              <span class="fw-medium fsc-12">(для склада)</span>
            </span>
          </div>
          <div @click="$modal.show('orderSendModal', { productId: 4, productName: 'Шины и диски', objectId: currentOpenedId })" style="padding-block: 12px; background-color: #023F8F; line-height: 20px;"
            class="text-center fsc-14 rounded-5 cursor-pointer text-white mb-10">
            ЗАКАЗАТЬ НОВЫЕ ЗИМНИЕ ШИНЫ <br/>
            <span class="fw-medium fsc-12" style="line-height: 12px;">с доставкой</span>

          </div>
          <div @click="$modal.show('orderSendModal', { productId: 5, productName: 'Шины б/у', objectId: currentOpenedId })" style="padding-block: 12px; background-color: #023F8F; line-height: 20px;"
            class="text-center fsc-14 rounded-5 cursor-pointer text-white">
            ЗАКАЗАТЬ Б/У ЗИМНИЕ ШИНЫ <br/>
            <span class="fw-medium fsc-12" style="line-height: 12px;">с доставкой</span>
          </div>
        </div>
      </div>
      <div class="col-4 px-0"></div>
    </div>
    <AddNewTriesModal :optionalParams="{ id: currentOpenedId }"></AddNewTriesModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import ObjectsService from '@/api/ObjectsService'

import AddNewTriesModal from '@/components/vehicles-page-single-modal-inner/AddNewTriesModal.vue'
import dayjs from 'dayjs'
import EventBus from '@/event-bus'
import axios from 'axios'
export default {
  components: {
    AddNewTriesModal
  },
  props: {
    modeOpenModal: {
      type: String,
      default: 'create'
    },

    currentOpenedId: {
      type: Number
    }
  },
  data() {
    return {
      loadingState: true,
      triesListForSend: [],
      triesList: [],
      API_PATH: '',
      updatedValues: {},
      currentActiveTires: ''
    }
  },
  methods: {
    async loadDoc(id) {
      let API_PATH = ''
      // if (process.env.VUE_APP_MODE_BUILD == 'serve-hmr' || process.env.VUE_APP_MODE_BUILD == 'testing') {
      //   API_PATH = 'crmtest'
      // } else {
      //   API_PATH = 'crmrent'
      // }

      switch (process.env.VUE_APP_MODE_BUILD) {
        case 'production':
          API_PATH = `https://converter.crmrent.com`
          break;
        case 'testing':
          API_PATH = `https://converter.crmtest.ru`
          break;
        case 'development':
          API_PATH = `http://converter.sirius.development`
          break;
        case 'serve-hmr':
          API_PATH = `http://converter.sirius.development`
          break;
      }
      try {
        // this.loadingState = true
        let dataFrom = await axios.get(
          `${API_PATH}/tires?id=${id}`,
          {
            responseType: 'blob',
            headers: {
              'X-Employee-Token': JSON.parse(
                localStorage.getItem('user-token')
              ),
              'Access-Control-Allow-Origin': '*'
            }
          }
        )
        const url = window.URL.createObjectURL(dataFrom.data)
        const a = document.createElement('a')
        a.href = url
        a.download = `Sirius_tyres.pdf`
        document.body.appendChild(a)
        a.click()
        a.remove()
      } catch (error) {
        console.error(error)
      } finally {
        // this.loadingState = false
      }
    },


    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      if (Object.keys(this.updatedValues).length) {
        ObjectsService.update(this.currentOpenedId, {
          ...{
            ...(this.currentActiveTires && {
              vehicle_cars__tires_id: this.currentActiveTires
            }),
            tires: this.triesListForSend
          }
        })
          .then((data) => {
            this.$toast.success(data.data.message)
            EventBus.$emit('contentLoaded')
            EventBus.$emit('updateContentData')
            callback(true, nameTab, oldTab, newTab, flagIsClose)
          })
          .catch((error) => {
            this.$toast.error(error.response.data.message, { duration: 5000 })
            callback(false, nameTab, oldTab, newTab)
          })
      } else {
        EventBus.$emit('contentLoaded')
        EventBus.$emit('updateContentData')
        callback(true, nameTab, oldTab, newTab, flagIsClose)
      }
    },
    changeDate(date, nameField, additionalParams) {
      this.findAndReplaceDataForSend(
        additionalParams,
        nameField,
        date
      )
      this.updatedValues[nameField] = date
    },
    changeCheckbox(data) {
      if (data.once == 'first') {
        this.triesList[0].isActive = true
        this.triesList[1].isActive = false
        this.currentActiveTires = this.triesListForSend[0].id
        this.triesListForSend[0].isActive = true
        this.triesListForSend[1].isActive = false
        this.updateValue(data)
      } else {
        this.triesList[0].isActive = false
        this.triesList[1].isActive = true
        this.currentActiveTires = this.triesListForSend[1].id
        this.triesListForSend[0].isActive = false
        this.triesListForSend[1].isActive = true
        this.updateValue(data)
      }
    },
    updateValue(data, www) {
      this.findAndReplaceDataForSend(data, data.name, data.value)

      this.updatedValues[data.name] = data.value

      // console.log(data);


      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove('input-error')
      }
    },
    findAndReplaceDataForSend(objectForCompare, field, rewriteData) {
      let inSend = this.triesListForSend.findIndex(
        (x) => x.id == objectForCompare.vehicle_tires__id
      )
      console.log(objectForCompare, field, rewriteData);

      // vehicle_tires__size
      if (inSend !== -1) {
        this.triesListForSend[inSend][field] = rewriteData
      }
      if (inSend !== -1 && field == 'vehicle_tires__size') {
        this.triesList[inSend]['vehicle_tires__size'] = rewriteData
      }
    },
    ...mapActions('transportVehiclesModule', ['getHealth', 'getTitle'])
  },
  created() {
    this.$emit('loadingModal', true)
    this.getHealth(this.currentOpenedId)
    this.getTitle(this.currentOpenedId)

    switch (process.env.VUE_APP_MODE_BUILD) {
      case 'serve-hmr':
        this.API_PATH = 'http://api.sirius.development'
        break
      case 'development':
        this.API_PATH = 'http://api.sirius.development'
        break
      case 'production':
        this.API_PATH = 'https://api.crmrent.com'
        break
      case 'testing':
        this.API_PATH = 'https://api.crmtest.ru'
        break
    }
    Promise.all([
      ObjectsService.getAll({ url: `/${this.currentOpenedId}/tires` })
        .then((data) => {
          data.data.data.rows.forEach((element) => {
            this.triesList.push({
              ...element,
              vehicle_tires__bought_at: dayjs(
                element.vehicle_tires__bought_at
              ).format(`${this.userSetting.company__tempalte_date}`)
            })
            this.triesListForSend.push({
              id: element.vehicle_tires__id,
              isActive: element.isActive
            })
          })
        })
        .catch((err) => { })
    ]).then(() => {
      this.$emit('loadingModal', false)
      this.loadingState = false
    })
  },
  computed: {
    currentUserToken() {
      return JSON.parse(localStorage.getItem('user-token'))
    },
    ...mapState('translationModule', ['dataLang']),
    ...mapGetters('transportVehiclesModule', ['numPages']),
    ...mapState('userSettingModule', ['userSetting'])
  }
}
</script>
